module.exports = __webpack_public_path__ + "assets/9253e8b73a4c6652aaaeebc5c19320e4.mp3";